"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionGroupRadioList = exports.textBoxOption = exports.TextBoxRadioButton = exports.openEndedOption = exports.OpenEndedRadioButton = exports.ErrorText = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var RadioButton_1 = require("@aon/aon-tws-common-ui/build/lib/components/Common/RadioButton");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var models_1 = require("../../models");
var common_1 = require("../common");
var ResponseOptionsTooltipContent_1 = require("./ResponseOptionsTooltipContent");
exports.ErrorText = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), aon_tws_common_ui_1.errorText);
exports.ErrorText.displayName = 'ErrorText';
exports.OpenEndedRadioButton = (0, styled_components_1.default)(RadioButton_1.RadioButton).attrs({
    className: 'tws-custom-question--open-ended-response-option',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.openEndedOption = {
    value: 0,
    name: 'open-ended',
    displayText: contentConstants_1.default.RESPONSE_OPTION_GROUP_OPENENDED,
    toolTip: (0, ResponseOptionsTooltipContent_1.ResponseOptionsTooltipContent)(contentConstants_1.default.RESPONSE_OPTION_GROUP_OPENENDED, [], contentConstants_1.default.RESPONSE_OPTION_GROUP_OPENEDED_DESCRIPTION),
};
exports.TextBoxRadioButton = (0, styled_components_1.default)(RadioButton_1.RadioButton).attrs({
    className: 'tws-custom-question--text-box-response-option',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.textBoxOption = {
    value: 0,
    name: 'text-box',
    displayText: contentConstants_1.default.RESPONSE_OPTION_GROUP_TEXTBOX,
    toolTip: (0, ResponseOptionsTooltipContent_1.ResponseOptionsTooltipContent)(contentConstants_1.default.RESPONSE_OPTION_GROUP_TEXTBOX, [], contentConstants_1.default.RESPONSE_OPTION_GROUP_TEXTBOX_DESCRIPTION),
};
var ResponseOptionGroupRadioList = /** @class */ (function (_super) {
    __extends(ResponseOptionGroupRadioList, _super);
    function ResponseOptionGroupRadioList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResponseOptionGroupRadioList.prototype.render = function () {
        var html = [];
        var responseOptionGroups = this.getResponseOptionGroups();
        var radioButtons = this.getRadioButtons(responseOptionGroups);
        if (radioButtons.length > 0) {
            var children = this.getRadioButtonColumns(radioButtons);
            if (this.props.errorMsg !== undefined && this.props.errorMsg !== '') {
                children.push(React.createElement(common_1.ColFull, { key: responseOptionGroups.length + 1 },
                    React.createElement(exports.ErrorText, null, this.props.errorMsg)));
            }
            html.push(React.createElement(common_1.Col2Col8Col2d, { key: '1' }, children));
        }
        return html;
    };
    ResponseOptionGroupRadioList.prototype.getRadioButtons = function (responseOptionGroups) {
        var _this = this;
        var _a = this.props, hasBeenSaved = _a.hasBeenSaved, selected = _a.selected, questionType = _a.questionType;
        var radioButtons = responseOptionGroups.map(function (item) {
            var disabled = hasBeenSaved && questionType !== models_1.QuestionType.Scale;
            var radioOption = __assign({}, item);
            return (React.createElement(RadioButton_1.RadioButton, { groupName: 'customResponseOptionGroups', isChecked: questionType !== models_1.QuestionType.OpenEnded && selected === item.value, key: item.value, size: 'lg', disabled: disabled, item: radioOption, handleChange: function () { return disabled || _this.props.onChange(item.value); }, showTooltips: true }));
        });
        if (radioButtons.length > 0) {
            var disableOpenEnded_1 = hasBeenSaved && questionType !== models_1.QuestionType.OpenEnded;
            var disableTextBox_1 = hasBeenSaved && questionType !== models_1.QuestionType.TextBox;
            var openEndedButton = (React.createElement(exports.OpenEndedRadioButton, { groupName: 'customResponseOptionGroups', isChecked: questionType === models_1.QuestionType.OpenEnded, key: 'open-ended', size: 'lg', disabled: disableOpenEnded_1, item: this.props.openEndedOption || exports.openEndedOption, handleChange: function () { return disableOpenEnded_1 || _this.props.setOpenEnded(); }, showTooltips: true }));
            radioButtons.push(openEndedButton);
            var textBoxButton = (React.createElement(exports.TextBoxRadioButton, { groupName: 'customResponseOptionGroups', isChecked: questionType === models_1.QuestionType.TextBox, key: 'text-box', size: 'lg', disabled: disableTextBox_1, item: this.props.textBoxOption || exports.textBoxOption, handleChange: function () { return disableTextBox_1 || _this.props.setTextBox(); }, showTooltips: true }));
            radioButtons.push(textBoxButton);
        }
        return radioButtons;
    };
    ResponseOptionGroupRadioList.prototype.getRadioButtonColumns = function (radioButtons) {
        var col1 = { type: '', props: '', key: '' };
        var col2;
        var children = [];
        for (var i = 0; radioButtons.length > i; i++) {
            if (i % 2 > 0) {
                col2 = radioButtons[i];
                children.push(React.createElement(common_1.ColHalves, { key: i, Col1: col1, Col2: col2 }));
            }
            else {
                col1 = radioButtons[i];
                // If there is an odd number of radio buttons, the last one needs to get pushed separately.
                if (i === radioButtons.length - 1) {
                    children.push(React.createElement(common_1.ColHalves, { key: i, Col1: col1, Col2: undefined }));
                }
            }
        }
        return children;
    };
    ResponseOptionGroupRadioList.prototype.sortResponseGroups = function (viewModels) {
        var responseOptionGroupCodes = this.props.responseOptionGroupCodes;
        var respGrp;
        var sortedViewModels = [];
        if (responseOptionGroupCodes) {
            responseOptionGroupCodes.forEach(function (code) {
                respGrp = viewModels.find(function (vm) { return vm.code === code; });
                if (respGrp !== undefined) {
                    sortedViewModels.push(respGrp);
                }
            });
        }
        return sortedViewModels;
    };
    ResponseOptionGroupRadioList.prototype.getResponseOptionGroups = function () {
        var orderedResponseOptionGroups = this.sortResponseGroups(this.props.responseOptionGroups);
        var responseOptionGroups = orderedResponseOptionGroups.map(function (responseOptionGroup) {
            var toolTip = responseOptionGroup.responseOptions === undefined || !responseOptionGroup.responseOptions.length
                ? undefined
                : (0, ResponseOptionsTooltipContent_1.ResponseOptionsByOrderedItemTooltipContent)(responseOptionGroup.displayText, responseOptionGroup.responseOptions);
            return {
                value: responseOptionGroup.responseOptionGroupId,
                name: responseOptionGroup.displayText,
                displayText: responseOptionGroup.displayText,
                toolTip: toolTip,
            };
        });
        return responseOptionGroups;
    };
    ResponseOptionGroupRadioList.defaultProps = {
        responseOptionGroupCodes: constants_1.default.CUSTOMQUESTION_RESPONSEOPTIONGROUP_CODES,
    };
    return ResponseOptionGroupRadioList;
}(React.Component));
exports.ResponseOptionGroupRadioList = ResponseOptionGroupRadioList;
var templateObject_1, templateObject_2, templateObject_3;
